export class ApiError extends Error {
    status;
    detail;
    code;
    validationErrors;
    constructor(status, detail, code, validationErrors) {
        super(detail);
        this.status = status;
        this.detail = detail;
        this.code = code;
        this.validationErrors = validationErrors;
        this.name = 'ApiError';
    }
}
export function parseApiErrorBody(status, body, fallback = 'Request failed') {
    const payload = typeof body === 'object' && body !== null
        ? body
        : {};
    const detail = typeof payload.detail === 'string'
        ? payload.detail
        : status > 0 ? `${fallback} (HTTP ${status})` : fallback;
    const code = typeof payload.code === 'string' ? payload.code : undefined;
    const validationErrors = Array.isArray(payload.errors)
        ? payload.errors.filter((issue) => typeof issue === 'object' && issue !== null)
        : undefined;
    return new ApiError(status, detail, code, validationErrors);
}
export async function apiErrorFromResponse(response, fallback = 'Request failed') {
    const body = await response.json().catch(() => undefined);
    return parseApiErrorBody(response.status, body, fallback);
}
//# sourceMappingURL=errors.js.map